import { Component, OnInit, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Group } from '../interfaces'

export interface GroupUsersDialogData {
  group: Group
}

@Component({
  selector: 'app-groups-dialog-users',
  templateUrl: './groups-dialog-users.component.html',
  styleUrls: ['./groups-dialog-users.component.scss'],
})
export class GroupsDialogUsersComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<GroupsDialogUsersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GroupUsersDialogData
  ) {}

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close()
  }
}
